const CreateSubPopup = ({ newSubUser, requestsLimit, setRequestsLimit, concurrency, setConcurrency, duration, setDuration, startedAt, setStartedAt, isStartedAtNow, setIsStartedAtNow, handleCloseCreateSub, handleCreateSubscription }) => {
    return <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
        <div className="bg-white p-6 rounded shadow-lg w-96">
            <h2 className="text-lg font-bold mb-4">Create Subscription for {newSubUser.display_name}</h2>
            <div className="space-y-2">
                <div>
                    <label className="block font-medium">Requests Limit</label>
                    <input
                        type="number"
                        className="border p-2 w-full"
                        value={requestsLimit}
                        onChange={(e) => setRequestsLimit(Number(e.target.value))}
                    />
                </div>
                <div>
                    <label className="block font-medium">Concurrency</label>
                    <input
                        type="number"
                        className="border p-2 w-full"
                        value={concurrency}
                        onChange={(e) => setConcurrency(Number(e.target.value))}
                    />
                </div>
                <div>
                    <label className="block font-medium">Duration (days)</label>
                    <input
                        type="number"
                        className="border p-2 w-full"
                        value={duration}
                        onChange={(e) => setDuration(Number(e.target.value))}
                    />
                </div>
                <div>
                    <label className="block font-medium">Started At</label>
                    <div className="flex items-center gap-2">
                        <label>Use now time:</label>
                        <input
                            type="checkbox"
                            checked={isStartedAtNow}
                            onChange={(e) => setIsStartedAtNow(e.target.checked)}
                        />
                    </div>
                    {!isStartedAtNow && (
                        <input
                            type="datetime-local"
                            className="border p-2 w-full"
                            value={startedAt}
                            onChange={(e) => setStartedAt(e.target.value)}
                        />
                    )}
                </div>
            </div>
            <div className="mt-4 flex justify-end gap-2">
                <button className="bg-gray-400 text-white p-2 rounded" onClick={() => handleCloseCreateSub()}>
                    Cancel
                </button>
                <button
                    className="bg-green-500 text-white p-2 rounded"
                    onClick={async () => {
                        await handleCreateSubscription();
                        handleCloseCreateSub();
                    }}
                >
                    Create
                </button>
            </div>
        </div>
    </div>
};
export default CreateSubPopup;